import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import NFTModal from "./NFTModal";
import nftLevel1Thumb from "../../assets/nftThumbs/nftLevel1Thumb.jpg";
import nftLevel2Thumb from "../../assets/nftThumbs/nftLevel2Thumb.jpg";
import nftLevel3Thumb from "../../assets/nftThumbs/nftLevel3Thumb.jpg";
import nftLevel4Thumb from "../../assets/nftThumbs/nftLevel4Thumb.jpg";
import nftLevel5Thumb from "../../assets/nftThumbs/nftLevel5Thumb.jpg";
import dxiotnftThumb from "../../assets/nftThumbs/dxiotnftThumb.jpg";
import linkThumb from "../../assets/nftThumbs/linkThumb.jpg";
import nftLevel1 from "../../assets/nftLevel1.jpg";
import nftLevel2 from "../../assets/nftLevel2.jpg";
import nftLevel3 from "../../assets/nftLevel3.jpg";
import nftLevel4 from "../../assets/nftLevel4.jpg";
import nftLevel5 from "../../assets/nftLevel5.jpg";
import dxiotnft from "../../assets/dxiotnft.jpg";
import linknft from "../../assets/linknft.jpg";
import NFTStore from "stores/NFTStore";
import { NFTInfo, NFTNames } from "types";
import "./NFTGrid.scss";

const nftItems = [
  {
    thumb: nftLevel1Thumb,
    fullSize: nftLevel1,
    name: "RAM1",
  },
  {
    thumb: nftLevel2Thumb,
    fullSize: nftLevel2,
    name: "RAM2",
  },
  {
    thumb: nftLevel3Thumb,
    fullSize: nftLevel3,
    name: "RAM3",
  },
  {
    thumb: nftLevel4Thumb,
    fullSize: nftLevel4,
    name: "RAM4",
  },
  {
    thumb: nftLevel5Thumb,
    fullSize: nftLevel5,
    name: "RAM5",
  },
  {
    thumb: dxiotnftThumb,
    fullSize: dxiotnft,
    name: "ROBOT",
    enabled: true,
  },
  {
    thumb: linkThumb,
    fullSize: linknft,
    name: "LINK",
    enabled: true,
  },
];

function NFTGrid() {
  const screenWidth = document.body.clientWidth;
  const hasBurger = screenWidth < 1024 ? true : false;
  const [showMenu, setShowMenu] = useState(false);
  if (hasBurger) {
    return (
      <div className="nft-menu">
        <div className="nft-toggle" onClick={() => setShowMenu((val) => !val)}>
          <b>{showMenu ? "Hide" : "Show"} NFTs</b>
        </div>
        {showMenu && <Grid />}
      </div>
    );
  }
  return <Grid />;
}

const Grid = observer(function () {
  const [selectedImage, setSelectedImage] = React.useState("");
  const [selectedNFT, setSelectedNFT] = React.useState<NFTInfo[]>();
  const [name, setName] = React.useState("");
  const { userNFTs } = NFTStore;
  return (
    <div className="nft-grid-container">
      {nftItems.map((nft) => {
        const userNFT = userNFTs.get(nft.name as NFTNames);
        const hasNFT = userNFT && userNFT.length > 0;
        return (
          <button
            key={`nft-card-${nft.name}`}
            className={`grid-card ${hasNFT && nft.enabled && "has-card"}`}
            onClick={() => {
              if (userNFT && userNFT.length > 0 && nft.enabled) {
                setSelectedImage(nft.fullSize);
                setSelectedNFT(userNFT);
                setName(nft.name);
              }
            }}
          >
            <div className="grid-card-inner">
              <div className="grid-card-front">
                <img src={nft.thumb} alt="thumb" />
              </div>
              <div className="grid-card-back">{userNFT && userNFT.length}</div>
            </div>
          </button>
        );
      })}
      <NFTModal selectedImage={selectedImage} setSelectedImage={setSelectedImage} NFTs={selectedNFT} name={name as NFTNames} />
    </div>
  );
});

export default observer(NFTGrid);
